import { useMemo } from "react";
import { useQuery } from "@apollo/client";
import { cmsClient } from "@/lib/cmsClient";
import type { ProductEligibility } from "../product.types";
import { parseProductEligibility } from "../mappers/product-eligibility.parse";
import GET_PRODUCT_ELIGIBILITY from "../graphql/GetProductEligibility.graphql";

export function useProductEligibility(productIds: string[]) {
    const uniqueIds = useMemo(
        () => Array.from(new Set(productIds)),
        [productIds],
    );

    const { data, loading } = useQuery<unknown>(GET_PRODUCT_ELIGIBILITY, {
        client: cmsClient,
        variables: { ids: uniqueIds },
        skip: uniqueIds.length === 0,
    });

    const eligibilityByProductId: Record<string, ProductEligibility> = useMemo(
        () => parseProductEligibility(data),
        [data],
    );

    return { eligibilityByProductId, loading };
}
